import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../helpers';
import { AppContextProvider } from '../../Services/AppContext';
import Modal from '../Modal/Modal';
import Button from '../Base/Button/Button';

loadDOMComponent({
	selector: 'react-modal-toggle',
	callback: ({ container }) => {
		const id = container.getAttribute('modal-id');

		const click = () => {
			var event = new Event('toggle');
			document.getElementById(id).dispatchEvent(event);
		};

		ReactDOM.render(
			<AppContextProvider>
				<Button text='toggle' onClick={click} />
			</AppContextProvider>,
			container,
		);
	},
});
